// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".over-flow[data-v-6d4bc514] {\n  overflow: hidden;\n}\n", ""]);
// Exports
module.exports = exports;
